<template>
  <div class="va-disclaimer d-flex align-center" :class="`va-disclaimer--${type}`">
    <div class="va-disclaimer__icon d-flex" :class="iconAlignmentClass">
      <slot name="icon">
        <v-icon :size="25" :color="iconColor">mdi-alert-circle</v-icon>
      </slot>
    </div>
    <div class="va-disclaimer__text d-flex flex-column spacing-right--24">
      <span class="va-disclaimer__text-title"> {{ title }} </span>
      <span class="va-disclaimer__text-content" v-html="text"></span>
    </div>
    <div class="va-disclaimer__action ml-auto d-flex align-center">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: "VaDisclaimer",
    props: {
      type: String,
      title: String,
      text: String,
      iconColor: {
        type: String,
        default: "warning",
      },
      iconAlignment: {
        type: String,
        default: "center",
      },
    },
    computed: {
      iconAlignmentClass() {
        switch (this.iconAlignment) {
          case "baseline":
            return "align-self-baseline";
          default:
            return "";
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
